import { PaymentRouteImport } from './Import'
const { RoutesMap, PaymentPage, PaymentResult } = PaymentRouteImport

const PaymentRoute = () => {
    return [
        {
            path: RoutesMap.PAYMENT.path,
            element: <PaymentPage />
        },
        {
            path: RoutesMap.PAYMENT_RESULT.path,
            element: <PaymentResult />
        },
    ]
}

export default PaymentRoute
